import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';
import LinkButton from '../atoms/button/LinkButton';

const ModalPlanOptionSummary = ({ open, onClose, subtitle, explanation, setShowPlanOptionModal }) => {

  return (
    <Modal
      open={open}
      onClose={() => setShowPlanOptionModal(false)}
      className="planOptionSummaryModal"
      bodyClassName="planOptionSummaryModalBody"
      overlayClassName="planOptionSummaryModalOverlay"
      disableBodyScroll={false}
      customHeader={() => (
          <div className="planOptionSummaryModalHeader">
            <div className="cautionModalClose" onClick={onClose}/>
          </div>
      )}
      >
      <div className="planOptionSummaryModalHeaderTitle">{subtitle}</div>
      <div className="planOptionSummaryModalExplanation" dangerouslySetInnerHTML={{ __html: explanation }} />
      <div className="planOptionSummaryModalCloseButton">
          <LinkButton onClick={() => setShowPlanOptionModal(false)} buttonType="navigateMin">
          閉じる
          </LinkButton>
      </div>
    </Modal>
  );
};

ModalPlanOptionSummary.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  subtitle: PropTypes.string.isRequired,
  explanation: PropTypes.string.isRequired,
  setShowPlanOptionModal: PropTypes.func.isRequired,
};

export default ModalPlanOptionSummary;